import AccountComponent from '@/components/Pages/Account.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/account',
  props: true,
  name: RouteNames.Account,
  component: AccountComponent,
};

export default route;
